import React, { useEffect, useState } from 'react';
// COMPONENTS
import Header from '../../../components/header';
import BuyNow from '../../../components/buyNowSection';
import Carousel from '../../../components/carousel';
import Footer from '../../../components/footer';
// ICONS
import { FaArrowLeft } from 'react-icons/fa';
// STYLES
import '../styles.css';
import Loader from '../../../components/loader';
import { useHistory } from 'react-router';

let data = {};

const DopplerInfo = () => {
  const history = useHistory();
  const alreadyLoggedIn = localStorage.getItem('token');
  if (!alreadyLoggedIn) {
    history.push('/');
  }
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch('http://192.168.18.40:8000/api/getDeviceInfo', {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        physicalId: localStorage.getItem('physicalId'),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setLoading(true);
        data = response;
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <div>
      <Header />
      <BuyNow />
      <Carousel />
      <section
        class='login-bg'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        {loading ? (
          <Loader />
        ) : (
          <div class='container'>
            <div class='container-sm-500'>
              <a href='/settings' class='back-arrow'>
                <FaArrowLeft />
              </a>
              <h2 class='text-left'>DOPPLER INFORMATION</h2>
              <p style={{ marginLeft: 34 }}>
                Serial number: {data ? data.serialNum : 'No device found'}
                <br />
                <br />
                Firmware version: {data ? data.firmware : 'No device found'}
                <br />
                <br />
                Hardware version: {data ? data.hardware : 'No device found'}
                <br />
                <br />
                Software version: {data ? data.software : 'No device found'}
              </p>
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default DopplerInfo;
